// import { hooks as commonHooks } from '@sitebuilder/common';
import React from 'react';
// import { useSelector } from 'react-redux';
// import { Route, Switch } from 'react-router-dom';
// import { StateShape as ReduxStateShape } from './reducers';
// import { createBrowserHistory } from 'history';
// import configureStore from './store';
// import { Provider } from 'react-redux';
import { auth as coreAuth } from '@sitebuilder/core';
import AdminRoutes from './routes/admin';

export interface AdminAppProps {
    user: coreAuth.User;
}
export const AdminApp = (props: AdminAppProps) => {
    // const { title } = useSelector((state: ReduxStateShape) => ({
    //     title:
    //         state?.templateEditor?.documentMetadata?.pageTitle ||
    //         state?.templateEditor?.documentMetadata?.fileName,
    // }));

    // const i18n = commonHooks.useLocalization();
    // const locale = i18n.getLocale();
    const { user } = props;

    console.log('AdminApp', { user });

    return (
        <React.Fragment>
            <AdminRoutes user={user} />
        </React.Fragment>
    );
};
